import React from "react";
import {
  Content,
  ContentVariants,
  List,
  ListItem,
  Flex,
  FlexItem
} from "@patternfly/react-core";

import {
  MapMarkerAltIcon,
  PhoneIcon,
  EnvelopeIcon
} from "@patternfly/react-icons";

import { footerConfig } from "../config/footerConfig";

import "./SchoolFooterContact.css";

const SchoolFooterContact = () => {
  const { contact } = footerConfig;

  return (
    <div className="school-footer-contact">
      <Content component={ContentVariants.h4}>
        Kontakt
      </Content>

      <List isPlain>

        <ListItem>
          <Flex
            spaceItems={{ default: "spaceItemsSm" }}
            alignItems={{ default: "alignItemsCenter" }}
          >
            <FlexItem>
              <MapMarkerAltIcon />
            </FlexItem>

            <FlexItem>
              {contact.address}
            </FlexItem>
          </Flex>
        </ListItem>

        <ListItem>
          <Flex
            spaceItems={{ default: "spaceItemsSm" }}
            alignItems={{ default: "alignItemsCenter" }}
          >
            <FlexItem>
              <PhoneIcon />
            </FlexItem>

            <FlexItem>
              <a
                className="school-footer-contact-link"
                href={`tel:${contact.phone}`}>
                {contact.phone}
              </a>
            </FlexItem>
          </Flex>
        </ListItem>

        <ListItem>
          <Flex
            spaceItems={{ default: "spaceItemsSm" }}
            alignItems={{ default: "alignItemsCenter" }}
          >
            <FlexItem>
              <EnvelopeIcon />
            </FlexItem>

            <FlexItem>
              <Content component={ContentVariants.a}
                // className="school-footer-contact-link school-footer-email"
                href={`mailto:${contact.email}`}>
                {contact.email}
              </Content>
            </FlexItem>
          </Flex>
        </ListItem>

      </List>
    </div>
  );
};

export default SchoolFooterContact;